// extracted by css-extract-rspack-plugin
export default {"noInventoryAvailable":"_c4033cf0"};